import React from "react";

function Row(props: any) {
  const { ducks, handleSelection, current, loading } = props;
  return (
    <div className="relative flex flex-row items-center justify-between rounded-3xl og-bg-opacity-black w-10/12 h-4/6 md:h-2/6 pb-2 px-2 pt-2 overflow-scroll self-end mx-auto my-3">
      <div
        className="flex flex-row items-center justify-around m-auto h-full"
      >
        {(!ducks && !loading) &&
          <div className="uppercase font-bold txt-white text-7xl md:text-6xl w-4/5 text-center m-auto">
            PLEASE SELECT A FILTER
          </div>
        }
        {
          loading && 
          <div className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        }
        {!!ducks && ducks.map((i:any, index:any) => (
          <div key={index} className="w-36 m-3 relative resize" onClick={()=> {handleSelection(i)}}>
            <img src={i.image_url} alt="" className={`rounded-lg resize ${current && (i.token_id === current.token_id) ? 'border-8	selected-img' : ''}`}/>
            <div className="absolute left-2 bottom-2 txt-white text-6xl md:text-sm rounded-lg og-bg-opacity-black py-1 px-2">
              #{i.token_id}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Row;